import PlanetSvgImg from '@/components/CustomIcons/PlanetSvgImg'
import AstronautSvgImg from '@/components/CustomIcons/AstronautSvgImg'
import AdaLogo from '~/components/CustomIcons/AdaLogo'
import BtcLogo from '~/components/CustomIcons/BtcLogo'
import DogeLogo from '~/components/CustomIcons/DogeLogo'
import EthLogo from '~/components/CustomIcons/EthLogo'
import XrpLogo from '~/components/CustomIcons/XrpLogo'
import EnifexLogo from '@/components/CustomIcons/EnifexLogo'
import EnifexWhiteLogo from '@/components/CustomIcons/EnifexWhiteLogo'
import InstagramLogo from '@/components/CustomIcons/InstagramLogo'
import TelegramLogo from '@/components/CustomIcons/TelegramLogo'
import LinkedInLogo from '@/components/CustomIcons/LinkedInLogo'
import TwitterLogo from '@/components/CustomIcons/TwitterLogo'
import FooterLogo from '@/components/CustomIcons/FooterLogo'
import SearchLoupe from '@/components/CustomIcons/SearchLoupe'
import ForgetPass from '@/components/CustomIcons/ForgetPass'
import ChangePass from '@/components/CustomIcons/ChangePass'
import WithdrawPass from '@/components/CustomIcons/WithdrawPass'
import TwoFaPass from '@/components/CustomIcons/2faPass'
import VerificationPass from '~/components/CustomIcons/VerificationPass'
import CryptoDeposit from '@/components/CustomIcons/CryptoDeposit'
import PathIcon from '@/components/CustomIcons/PathIcon'
import EllipseIcon from '@/components/CustomIcons/EllipseIcon'
import MissionIcon from '@/components/CustomIcons/MissionIcon'
import TechnologyIcon from '@/components/CustomIcons/TechnologyIcon'
import EmailIcon from '@/components/CustomIcons/EmailIcon'
import PhoneIcon from '@/components/CustomIcons/PhoneIcon'
import LocationIcon from '@/components/CustomIcons/LocationIcon'
import BannerLogo from '@/components/CustomIcons/BanerLogo'
import ArrowRight from '@/components/CustomIcons/Arrow-right'
import CloseIcon from '@/components/CustomIcons/CloseIcon'
import ChartIcon from '@/components/CustomIcons/ChartIcon'
import ArrowIcon from '@/components/CustomIcons/ArrowIcon'
import TradeIcon from '@/components/CustomIcons/TradeIcon'
import QuestionIcon from '@/components/CustomIcons/QuestionIcon'
import NavigationTextureLogo from '~/components/CustomIcons/NavigationTextureLogo'
import AppleLogo from '@/components/CustomIcons/AppleLogo'
import AndroidLogo from '@/components/CustomIcons/AndroidLogo'
import GooglePlayLogo from '@/components/CustomIcons/GooglePlayLogo'
import AssetsIcon from '@/components/CustomIcons/AssetsIcon'
import NavAssetsIcon from '@/components/CustomIcons/NavAssetsIcon'
import SearchIcon from "@/components/CustomIcons/SearchIcon"
import ArrowIconLeft from "@/components/CustomIcons/ArrowIconLeft"
import ArrowIconRight from "@/components/CustomIcons/ArrowIconRight"
import FavoriteIcon from "@/components/CustomIcons/FavoriteIcon"
import hamburgerMenu from "@/components/CustomIcons/hamburgerMenu"
import LearningIcon from "~/components/CustomIcons/LearningIcon"
import FacebookLogo from "~/components/CustomIcons/FacebookLogo"
import YoutubeLogo from "~/components/CustomIcons/YoutubeLogo"
import DiscordLogo from "~/components/CustomIcons/DiscordLogo"
import TiktokLogo from "~/components/CustomIcons/TiktokLogo"

const CustomIcons = {
  FacebookLogo: {
    component: FacebookLogo,
  },
  YoutubeLogo: {
    component: YoutubeLogo,
  },
  DiscordLogo: {
    component: DiscordLogo,
  },
  TiktokLogo: {
    component: TiktokLogo,
  },
  LearningIcon: {
    component: LearningIcon,
  },
  FavoriteIcon: {
    component: FavoriteIcon,
  },
  hamburgerMenu: {
    component: hamburgerMenu,
  },
  ArrowIconRight: {
    component: ArrowIconRight,
  },
  ArrowIconLeft: {
    component: ArrowIconLeft,
  },
  SearchIcon: {
    component: SearchIcon,
  },
  NavAssetsIcon: {
    component: NavAssetsIcon,
  },
  AssetsIcon: {
    component: AssetsIcon,
  },
  AppleLogo: {
    component: AppleLogo,
  },
  AndroidLogo: {
    component: AndroidLogo,
  },
  GooglePlayLogo: {
    component: GooglePlayLogo,
  },
  NavigationTextureLogo: {
    component: NavigationTextureLogo,
  },
  QuestionIcon: {
    component: QuestionIcon,
  },
  TradeIcon: {
    component: TradeIcon,
  },
  ArrowIcon: {
    component: ArrowIcon,
  },
  ChartIcon: {
    component: ChartIcon,
  },
  BannerLogo: {
    component: BannerLogo,
  },
  CloseIcon: {
    component: CloseIcon,
  },
  LocationIcon: {
    component: LocationIcon,
  },
  PhoneIcon: {
    component: PhoneIcon,
  },
  EmailIcon: {
    component: EmailIcon,
  },
  TechnologyIcon: {
    component: TechnologyIcon,
  },
  MissionIcon: {
    component: MissionIcon,
  },
  CryptoDeposit: {
    component: CryptoDeposit,
  },
  EllipseIcon: {
    component: EllipseIcon,
  },
  PathIcon: {
    component: PathIcon,
  },
  VerificationPass: {
    component: VerificationPass,
  },
  TwoFaPass: {
    component: TwoFaPass,
  },
  WithdrawPass: {
    component: WithdrawPass,
  },
  ChangePass: {
    component: ChangePass,
  },
  ForgetPass: {
    component: ForgetPass,
  },
  PlanetSvgImg: {
    component: PlanetSvgImg,
  },
  SearchLoupe: {
    component: SearchLoupe,
  },
  FooterLogo: {
    component: FooterLogo,
  },
  EnifexLogo: {
    component: EnifexLogo,
  },
  EnifexWhiteLogo: {
    component: EnifexWhiteLogo,
  },
  TelegramLogo: {
    component: TelegramLogo,
  },
  LinkedInLogo: {
    component: LinkedInLogo,
  },
  TwitterLogo: {
    component: TwitterLogo,
  },
  InstagramLogo: {
    component: InstagramLogo,
  },
  AstronautSvgImg: {
    component: AstronautSvgImg,
  },
  AdaLogo: {
    component: AdaLogo,
  },
  BtcLogo: {
    component: BtcLogo,
  },
  DogeLogo: {
    component: DogeLogo,
  },
  EthLogo: {
    component: EthLogo,
  },
  XrpLogo: {
    component: XrpLogo,
  },
  ArrowRight: {
    component: ArrowRight,
  },
}

export default CustomIcons
